<template>
    <h2>{{ greeting }}</h2>
</template>

<style lang="scss"></style>

<script>
    export default {
        name: 'GreetingTitle',

        data()
        {
            return {
                greeting: 'Goedemorgen!'
            };
        },

        mounted()
        {
            this.determineCurrentHours();
        },

        methods: {
            determineCurrentHours()
            {
                // Retrieving current time first.
                let DateObject = new Date();
                let currentHour = DateObject.getHours();

                if( currentHour < 6 ) // Night
                {
                    this.greeting = 'Goedenacht!\xA0🌑';
                }
                else if( currentHour < 12 ) // Morning
                {
                    this.greeting = 'Goedemorgen!\xA0🌄';
                }
                else if( currentHour < 18 ) // Midday
                {
                    this.greeting = 'Goedemiddag!\xA0🌞';
                }
                else if( currentHour < 24 ) // Evening
                {
                    this.greeting = 'Goedenavond!\xA0🌇';
                }
            }
        }
    };
</script>
